<template>
    <div class="page-scan-special">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">澳門門店</div>
            <div class="breadcrumb-item">特殊掃描</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="11" push="5">
                        <Form :label-width="150">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>快遞單號</span>
                                </div>
                                <Input v-model="form.odd_numbers" @keyup.enter.native="onRemarks"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>備註</span>
                                </div>
                                <Input ref='remarks' v-model="form.remarks" @keyup.enter.native="onSearch"></Input>
                            </FormItem>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <!-- <div ref="select" class="pg-btn style1" @click="handleCheckForm">確定</div> -->
                                    <div ref="select" class="pg-btn style1">確定</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                form: {
                    odd_numbers: '',
                    remarks: ''
                },
                isSubmiting: false
            };
        },
        methods: {
			onRemarks() {
				this.$refs.remarks.focus();
			},
			onSearch() {
				this.handleCheckForm();
			},
            handleCheckForm()
            {
                let form = this.form;
                if (form.odd_numbers === '')
                {
                    this.$Utils.showTipInfo('請輸入快遞單號');
                    return;
                } else if (form.remarks === '')
                {
                    this.$Utils.showTipInfo('請輸入備註');
                    return;
                }
                this.handleSubmit();

            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.scanSpecial,
                    method: 'post',
                    data: {
                        odd_numbers: form.odd_numbers,
                        remarks: form.remarks
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        this.form = {
                            odd_numbers: '',
                            remarks: ''
                        };
                    } 
                    else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "ScanSpecial.scss";
</style>